import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import React from "react";

interface IConfirmProps {
  message: string;
  title: string;
  confirmText: string;
  cancelText?: string;
}


export const confirm: (props: IConfirmProps) => Promise<boolean> = (
  props: IConfirmProps,
) =>
  new Promise((resolve) => {

    modals.openConfirmModal({
      title: props.title,
      children: (
        <Text size="sm">
          {props.message}
        </Text>
      ),
      labels: {
        confirm: props.confirmText,
        cancel: props.cancelText,
      },

      onCancel: () => resolve(false),
      onConfirm: () => resolve(true),
    });
  });
